import { SmallLoader } from 'components/shared/Loader';
import React, { useState } from 'react';
import FeatureConfigureModal from './FeatureConfigureModal';
import { FiEdit } from 'react-icons/fi';

interface UsageLimits {
    id: string;
    feature: string;
    unit: string;
    cost: string;
}

const UsageLimits = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [UsageLimits, setUsageLimits] = useState<UsageLimits[]>([
        {
            id: "1",
            feature: "Users",
            unit: "Number",
            cost: "$200"
        },
        {
            id: "2",
            feature: "Users",
            unit: "Number",
            cost: "$300"
        },
        {
            id: "3",
            feature: "Users",
            unit: "Number",
            cost: "$400"
        },
        {
            id: "4",
            feature: "Users",
            unit: "Number",
            cost: "$500"
        }
    ]);
    const [mode,setMode] = useState("add");
    const [editItemId,setEditItemId] = useState("");
    const [currentPage, setCurrentPage] = useState(1); // starts from 1
    const itemsPerPage = 2; // you can change this number

    const totalPages = Math.ceil(UsageLimits.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentUsageLimits = UsageLimits.slice(startIndex, endIndex);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleConfigureOpen = () => {
        setIsOpen(true);
        setMode("add");
    };

    const handleEditUsage = (id: string) => {
        setMode("edit");
        setEditItemId(id);
        setIsOpen(true);
    };

    return (
        <div className="w-full">
            <div className="flex justify-between items-center my-5">
                <h1 className="text-lg font-semibold text-white">Usage limits</h1>
                <button
                    onClick={handleConfigureOpen}
                      className="flex items-center gap-2 px-4 py-2 bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                >

                    Configure
                </button>
            </div>

            <div className="bg-[#2A2A2A]  overflow-hidden rounded-lg">
                <div className="w-full overflow-x-auto bg-[#2A2A2A] ">
                    <table className="min-w-full ">
                        <thead className="bg-[#1A1A1A]">
                            <tr >
                                <th className="text-left p-4 font-medium">
                                    Feature
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Unit
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Cost
                                </th>
                                <th className="text-right p-4 font-medium">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody className="">
                            {isLoading ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center">
                                        <div className="flex justify-center">
                                            <SmallLoader />
                                        </div>
                                    </td>
                                </tr>
                            ) : UsageLimits.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center text-gray-400">
                                        No discount codes found
                                    </td>
                                </tr>
                            ) : (
                                currentUsageLimits.map((feature) => (
                                    <tr key={feature.id} className='border-b border-white/[0.08] hover:bg-[#3a3a3a33]'>
                                        <td className="p-4 text-gray-300">
                                            {feature.feature}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {feature.unit}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {feature.cost}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <div className="flex justify-end gap-3">
                                                <button
                                                    onClick={() => handleEditUsage(feature.id)}
                                                    className="text-blue-500 hover:text-blue-400"
                                                >
                                                    <FiEdit size={18} />
                                                </button>
                                                {/* <button
                                                    onClick={() => openDeleteModal(code.id)}
                                                    className="text-red-500 hover:text-red-400"
                                                >
                                                    <FiTrash2 size={18} />
                                                </button> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
 <div className="flex items-center justify-between mt-4 text-sm text-gray-400">
                    <div>
                        Showing {startIndex + 1}-{Math.min(endIndex, UsageLimits.length)} from {UsageLimits.length}
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="p-2 hover:text-white disabled:opacity-50"
                        >
                            ←
                        </button>
                        {pages.map(page => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`w-8 h-8 rounded flex items-center justify-center ${currentPage === page
                                        ? 'bg-[#3A3A3A] text-white'
                                        : 'hover:text-white'
                                    }`}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className="p-2 hover:text-white disabled:opacity-50"
                        >
                            →
                        </button>
                    </div>
                </div>
                

            {isOpen && <FeatureConfigureModal 
            mode={mode} setMode={setMode} editItemId={editItemId} dataList={UsageLimits}
            setDataList={setUsageLimits}
            setData={(newItems: UsageLimits[]) =>
            setUsageLimits((prev) => [...prev, ...newItems])} type="usage-limits" isOpen={isOpen} onClose={() => setIsOpen(false)} />}

        </div>
    );
};

export default UsageLimits;
